import TextField from "@/components/layouts/History/TextField";
import { getCurrencySymbol } from "@/pages/deals/helpers";
import { currencyCodeFromSetting } from "@/utils/numbers";
import { useAccountSettingByKey } from "@/entities/settings/hooks";
import { getCurrentLocale } from "@/utils/locale";
import { formatNumber } from "@/utils/numbers";

interface Props {
  value: number;
}

const DealValueAmount: React.FC<Props> = ({ value }) => {
  const accountCurrencySetting =
    useAccountSettingByKey("account_currency").data;
  // Narrowed, not cast: `|| ""` lets a boolean `true` through, and this
  // interpolates into a template literal below — so the figure would read
  // "undefined1,234", the same symptom already fixed on the contract panels.
  const currency = currencyCodeFromSetting(accountCurrencySetting?.value);
  // Coalesced at the interpolation boundary, not just the type one: a resolved
  // code is not enough, because getCurrencySymbol answers undefined for a real
  // currency its package does not carry (FJD, XCD), and the template literal
  // below would print that as the text "undefined".
  const accountCurrencySymbol = currency
    ? (getCurrencySymbol(currency) ?? "")
    : "";
  const { value: formattedValue } = formatNumber(
    value,
    0,
    false,
    false,
    false,
    getCurrentLocale()
  );
  return <TextField>{`${accountCurrencySymbol}${formattedValue}`}</TextField>;
};

export default DealValueAmount;
